import colors from './Colors';
import spacing from './Spacing';
export const shadowLight = `0 1px 4px hsl(0 0% 0% / 16%)`;
export const shadowDark = `0 2px 8px hsl(0 0% 0% / 32%)`;
export const card = `
  background: ${colors.backgroundPrimary};
  border: 1px solid ${colors.borderDark};
  border-radius: ${spacing.xs};
  height: 100%;
  padding: ${spacing.lg};
  position: relative;
`;
export const lineClamp = (lines) => {
    return `
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
    overflow: hidden;
    padding-bottom: 0 !important;
  `;
};
export const stack = (space = spacing.lg) => {
    return `
    > * + * {
      margin-top: ${space} !important;
    }
  `;
};
